import { createSelector } from "reselect";
import { STATS_DOMAIN } from "./constants";
import { initialState } from "./reducer";


const selectStatsDomain = state => {
  return state[STATS_DOMAIN] || initialState;
}

export function selectStats(id){
  return createSelector(selectStatsDomain, (stats) => {
    return stats.stats[id];
  })
}

export const selectInspectionStats = () =>
  createSelector(
    selectStatsDomain,
    (stats) => stats?.inspectionStats
  );